module.exports = __webpack_public_path__ + "de77a722/img/link-icon.fa09ed66.svg";